/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { NotificationPolicy } from '../models/NotificationPolicy';

export class ListNotificationPoliciesResponse {
  'notificationPolicies': Array<NotificationPolicy>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "notificationPolicies",
      "baseName": "notificationPolicies",
      "type": "Array<NotificationPolicy>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ListNotificationPoliciesResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

